import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Button from '@mui/material/Button'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  isRetrying: boolean
  tryAgain(): void
}

export default function PaymentsSettingsError(props: Props): JSX.Element {
  const { t } = useTranslation()

  return (
    <Alert severity="error" sx={{ mt: 2 }}>
      <AlertTitle>{t('weCoundntFetchYourItemCorrectly', { item: t('paymentSettings') })}</AlertTitle>
      <Button onClick={props.tryAgain} disabled={props.isRetrying}>{t('tryAgain')}</Button>
    </Alert>
  )
}
